import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Button } from "@mui/material";
import { useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import CustomTable from "../../../components/common/CustomTable/CustomTable";
import '../../../assets/styles/facturacionv3-app.css'

const columns = [
    { type: 'options', field: 'options', label: 'Acciones', align:'center' },
    { type: 'text', field: 'code', label: 'Código producto', align:'center' },
    { type: 'text', field: 'description', label: 'Descripcion', align:'center' },
    { type: 'text', field: 'cost', label: 'Costo', align:'center' },
    { type: 'text', field: 'price', label: 'Precio', align:'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align:'center' },
];

const listProducts = []

type Values = {
    id: number,
    name: string,
    validity: string,
    status: string,
}

export const AddProductModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, storeSelected, liststore, clearState } = props;

    const { createStore, editStore } = useStoreStore();

    const [loading, setLoading] = useState<boolean>(false);
    const [showModalAddProduct, setShowModalAddProduct] = useState<boolean>(false);
    const [data, setData] = useState<Values>({
        id: storeSelected ? storeSelected.id :'',
        name: storeSelected ? storeSelected.name :'',
        validity: storeSelected ? storeSelected.validity :'',
        status: storeSelected ? storeSelected.status :'',
    });

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.validity) errors.validity = "el campo es requerido";
        return errors;
    }

    const addProducts = () => {
        setShowModalAddProduct(true);
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        const idcompanies = (values.idcompanies).map(company => company.id) || [];

        const formdata = {
            ...values,
            type_person: '0',
            age: (values.age).toString(),
            idcompanies: JSON.stringify(idcompanies),
            password_confirmation: values.password,
        }

        if(storeSelected){
            const response:any = await editStore(storeSelected.id, formdata);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createStore(formdata);
            if(response){
                liststore && liststore();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <>
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="lg" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out' }}}>
            <ModalHeader
                text={'Agregar productos'}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12}>
                                            <CustomTable 
                                                disabled_title
                                                columns={columns}
                                                loading={loading}
                                                rows={listProducts || []}
                                                onRowClick={() => {}}
                                                onSearch
                                                dense
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={'Guardar'}
                                    onConfirm={handleSubmit}
                                    cancelText={"Cancelar"}
                                    onCancel={closeModal}
                                    loadingConfirmText={loading}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
        </>
    )
}